import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeRegularUser from './envelope-regular-user-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeRegularUser {...validProps} />;
}

SvgComponent.iconName = 'envelopeRegularUser';

export const EnvelopeRegularUserIcon = svgIconWrapper(SvgComponent);
